import React from "react";
import NoImage from "../../../assets/img/no_image.png"
import NoProfile from "../../../assets/img/default-avatar.png";
import AudioImage from "../../../assets/img/Letflow/SmartSearch/audio.png";
import Pdf from "../../../assets/img/Letflow/SmartSearch/pdf.jpeg";
import Video from "../../../assets/img/Letflow/SmartSearch/video.jpeg";
import "./index.css"
import {makeImageCarousel} from "../../../layouts/Home/HomeElements/HomeElementCarouselItem";
import {Image, PlayCircleFilled, Headset, Description, Share} from "@material-ui/icons";
import {ReactComponent as Star} from "../../../components/Letflow/SvgIcons/star.svg"
import {ReactComponent as List} from "../../../components/Letflow/SvgIcons/list.svg"
import {homePathGenerator} from "../../../api-client/core/authentication/utils";
import Link from "react-router-dom/Link";
import moment from "moment";
import EventManager, {events} from "../../../utils/EventManager";
import AddToPlaylist from "../AddToPlaylist";
import localization from "../../../config/localization";
import {Tooltip} from "@material-ui/core";

const getIcon = (creation) => {
    if (!!creation.video) {
      return <PlayCircleFilled style={{color: "#727272"}} />;
    }else if (!!creation.audio) {
      return <Headset style={{color: "#727272"}} />;
    }else if (!!creation.binary) {
      return <Description style={{color: "#727272"}} />;
    }else if (!!creation.embededContent) {
      if(creation.embededContent.source === "spotify") {
        return <Headset style={{color: "#727272"}} />;
      }
      return <PlayCircleFilled style={{color: "#727272"}} />;
    }else {
      return <Image style={{color: "#727272"}} />;
    }
}

const getNoImage = (creation) => {
  if (!!creation.video) {
    return Video;
  }else if (!!creation.audio) {
    return AudioImage;
  }else if (!!creation.binary) {
    return Pdf;
  }else {
    return NoImage;
  }
}

const openContentCreatorModal = (creator) => {
  EventManager.getInstance().dispatch(events.OPEN_CONTENT_MODAL, {id: creator.id, dataType: "contentCreator", dataName: creator.name, onTagChange: false});
}

const getImage = creation => {
  if (creation.image) {
    return makeImageCarousel(creation);
  } else if (creation.video && creation.video.thumbnail) {
    return makeImageCarousel({image: creation.video.thumbnail});
  }

  return getNoImage(creation)
}


const CreationItem = ({contentCreation, onFavorite, onPlay, onShare, isPublic = false, extraHeight = false, showDescription = false, hideAuthor = false}) => {
    return(
      <div className={"creation-card"}>
        <div className={extraHeight ? "creation-img-extra-height-container" : "creation-img-container"}>
          <div
            className={"creation-img"}
            onClick={onPlay}
            style={{
              backgroundImage: `url(${getImage(contentCreation)})`}}/>
          {!isPublic &&
          <div className={"creation-over-actions"}>
            {/*{!!contentCreation.favorite ?*/}
            <Tooltip placement="bottom"
                     title={localization.get(contentCreation.favorite ? "soundbar.remove_from_favorites" : "soundbar.add_to_favorites")}>
              <Star
                className={`creation-over-actions-item ${contentCreation.favorite ? "creation-over-actions-item-active" : ""}`}
                style={{fontSize: 30,}} onClick={onFavorite}
              />
            </Tooltip>
            <AddToPlaylist
              id={contentCreation.id}
              content={"contentCreations"}
              icon={<Tooltip placement="bottom" title={localization.get("add_to_playlist")}>
                <List className={"creation-over-actions-item"}
                      style={{fontSize: 33, right: 10, cursor: "pointer", marginTop: 3}}/>
              </Tooltip>}
            />
            {onShare &&
              <Tooltip placement="bottom" title={localization.get("share")}>
                <Share
                  className={"creation-over-actions-item"}
                  style={{fontSize: 2, marginTop: 2, cursor: "pointer", height: 26,width: 24}}
                  onClick={() => onShare(contentCreation.id)}
                />
              </Tooltip>
            }
          </div>
          }
        </div>
        <div className={"creation-info"}>
          <div className={"creation-type"}>
            {getIcon(contentCreation)}
          </div>
          <div className={"creation-data"}>
            <h3 onClick={onPlay} style={{cursor: "pointer"}}>{contentCreation.title}</h3>
            {showDescription && contentCreation.description && <h3 onClick={onPlay} style={{cursor: "pointer", fontWeight: "normal", color: "#838383", marginTop: 0}}>{contentCreation.description}</h3>}
            {!hideAuthor && contentCreation.contentCreator && 
              <div className={"creation-author"}>
                <div
                  className={"creation-author-image"}
                  style={{backgroundImage: `url(${!!contentCreation.contentCreator.image ? makeImageCarousel(contentCreation.contentCreator, {width: 15, height: 15, fit: false}) : NoProfile})`}}
                />
                <Link
                  className={"creation-author-name"}
                  to={homePathGenerator(isPublic ? `public/content_creators/${contentCreation.contentCreator.hashcode}` : `contenido/${contentCreation.contentCreator.id}-${contentCreation.contentCreator.name}`)}
                  onClick={e => {
                    if(!isPublic) {
                      e.preventDefault();
                      openContentCreatorModal(contentCreation.contentCreator)
                    }
                  }}
                >{contentCreation.contentCreator.name}</Link>
              </div>
            }
        </div>
        {/*<div className={"creation-id"}>
          <h3 style={{borderLeft: "2px solid black", paddingLeft: 3, textAlign: "right"}}>{moment(contentCreation.created_at,"YYYY/MM/DD H:m:s").format("YYYY")}</h3>
        </div>*/}
      </div>
    </div>
    );
}
export default CreationItem
